export default function getShortFileName(fileName: string, nameLengthToDisplay = 20): string {
  if (fileName.length > 20) {
    const extension = fileName.split('.')[1];
    return `${fileName.substr(0, nameLengthToDisplay)}...${extension}`;
  }

  return fileName;
}
